import { __decorate, __metadata } from "tslib";
import { Component } from 'decorators';
import * as styles from './cardHint.module.scss';
import template from './CardHintView.html';
let CardHintComponent = class CardHintComponent {
    constructor() {
        this.styles = styles;
        this.isOpen = true;
    }
};
CardHintComponent = __decorate([
    Component({
        template,
        transclude: true,
        bindings: {
            canClose: '<?',
            alignment: '@?',
        },
    }),
    __metadata("design:paramtypes", [])
], CardHintComponent);
export { CardHintComponent };
